
import Innerbannerlines from "@/../../public/images/inner-banner-lines.svg";
import Logoicon from "@/../../public/images/fav-icon.svg";
import Breadcrumb from "react-bootstrap/Breadcrumb";
import JobDetails from "../common/job-details";
import { useLocation } from "react-router-dom";

const JobDetailsScreen = () => {
  // const { id } = useParams<{ id: string }>();
  // const [jobId, setJobId] = useState(id); // Set it in the state
  const location = useLocation();
  const { jobId } = location?.state || {}; // Access the passed state
  // useEffect(() => {
  //   setJobId(id);
  // }, [id]);
  return (
    <>
      {/* <HeaderScreen /> */}
      <div className="front-pages">
        <section className="home-banner innerBanner position-relative common-padd-xl">
          <div className="homeLine">
            <img src={Innerbannerlines} alt="line icon" />
          </div>
          <div className="container">
            <div className="row">
              <div className="col-lg-12">
                <div className="innerBanner-info text-center">
                  <h1>Digital Marketing Specialist</h1>
                  <div className="breadcrumb-holder text-center">
                    <Breadcrumb>
                      <Breadcrumb.Item href="#">
                        <img src={Logoicon} alt="logo icon" /> Home
                      </Breadcrumb.Item>
                      <Breadcrumb.Item href="/job-listing">
                        {" "}
                        Jobs
                      </Breadcrumb.Item>
                      <Breadcrumb.Item active>
                        Digital Marketing Specialist
                      </Breadcrumb.Item>
                    </Breadcrumb>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        <div className="col-lg-8 offset-lg-2 rightcontent p-0">
          <JobDetails jobId={jobId} />
        </div>

        {/* <section className="jobdetails-holder position-relative common-padd-xl pt-0">
          <div className="container">
            <div className="row">
              <div className="col-lg-3">
                <h3>Job Information</h3>
                <div className="jobInformation comnbrdrGap mb-5">
                  <ul>
                    <li>
                      <span>
                        <FiUserCheck />
                      </span>
                      <h4>
                        Employee Type: <strong>Full Time</strong>
                      </h4>
                    </li>
                    <li>
                      <span>
                        <SlLocationPin />
                      </span>
                      <h4>
                        Location: <strong>Beijing, China</strong>
                      </h4>
                    </li>
                    <li>
                      <span>
                        <HiOutlineBuildingOffice2 />
                      </span>
                      <h4>
                        Company Name: <strong>DataVision Analytics</strong>
                      </h4>
                    </li>
                    <li>
                      <span>
                        <BsBriefcase />
                      </span>
                      <h4>
                        Job Type: <strong>Marketing & PR (8)</strong>
                      </h4>
                    </li>
                    <li>
                      <span>
                        <LiaMedalSolid />
                      </span>
                      <h4>
                        Experience: <strong>2+ years</strong>
                      </h4>
                    </li>
                    <li>
                      <span>
                        <AiOutlineDollarCircle />
                      </span>
                      <h4>
                        Salary: <strong>$4000 - $4500</strong>
                      </h4>
                    </li>
                    <li>
                      <span>
                        <MdUpdate />
                      </span>
                      <h4>
                        Date posted: <strong>28th Feb, 2023</strong>
                      </h4>
                    </li>
                  </ul>
                </div>
              </div>
              <div className="col-lg-9">
                <div className="row">
                  <div className="col-lg-12">
                    <div className="jobDetails-info">
                      <div className="singlestep mb-5">
                        <h3>Job Description:</h3>
                        <p>
                          One disadvantage of Lorum Ipsum is that in Latin
                          certain letters appear more frequently than others -
                          which creates a distinct visual impression. Moreover,
                          in Latin only words at the beginning of sentences are
                          capitalized.
                        </p>
                        <p>
                          This means that Lorem Ipsum cannot accurately
                          represent, for example, German, in which all nouns are
                          capitalized. Thus, Lorem Ipsum has only limited
                          suitability as a visual filler for German texts. If
                          the fill text is intended to illustrate the
                          characteristics of different typefaces.
                        </p>
                        <p>
                          It sometimes makes sense to select texts containing
                          the various letters and symbols specific to the output
                          language.
                        </p>
                      </div>
                      <div className="singlestep mb-5">
                        <h3>Required Experience, Skills and Qualifications:</h3>
                        <p>
                          It sometimes makes sense to select texts containing
                          the various letters and symbols specific to the output
                          language.
                        </p>
                        <ul className="rightliarrow">
                          <li>
                            Proven experience as a .NET Developer or Application
                            Developer
                          </li>
                          <li>
                            Good understanding of SQL and Relational Databases,
                            specifically Microsoft SQL Server.
                          </li>
                          <li>
                            Experience designing, developing and creating
                            RESTful web services and APIs
                          </li>
                          <li>Basic know how of Agile process and practices</li>
                          <li>
                            Good understanding of object-oriented programming.
                          </li>
                          <li>Good understanding of concurrent programming.</li>
                          <li>
                            Sound knowledge of application architecture and
                            design.
                          </li>
                          <li>
                            Excellent problem solving and analytical skills
                          </li>
                        </ul>
                      </div>
                      <div className="singlestep mb-5">
                        <h3>Responsibilities and Duties:</h3>
                        <p>
                          It sometimes makes sense to select texts containing
                          the various letters and symbols specific to the output
                          language.
                        </p>
                        <ul className="rightliarrow">
                          <li>Participate in requirements analysis</li>
                          <li>
                            Write clean, scalable code using C# and .NET
                            frameworks
                          </li>
                          <li>
                            Experience designing, developing and creating
                            RESTful web services and APIs
                          </li>
                          <li>Revise, update, refactor and debug code</li>
                          <li>Improve existing software</li>
                          <li>
                            Develop documentation throughout the software
                            development life cycle (SDLC)
                          </li>
                          <li>
                            Serve as an expert on applications and provide
                            technical support
                          </li>
                        </ul>
                        <a href="#" className="btn">
                          Apply Now
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section> */}
        {/* <section className="jobdetails-holder position-relative common-padd-xl pt-0">
          <div className="container">
            <div className="row">
              <div className="col-lg-12 text-center mb-3">
                <h2>Related Job Posts</h2>
                <p>
                  Search all the open positions on the web. Get your own
                  personalized salary estimate.
                </p>
              </div>
              <div className="col-lg-12">
                <div className="row">
                  <div className="col-lg-3">
                    <div className="jobboxholder">
                      <div className="jobboxholdertop">
                        <h4>Software Engineering</h4>
                        <p>
                          <MdOutlineWatchLater /> posted 3days ago
                        </p>
                        <div className="timeprice">
                          <div className="timezone">Full Time</div>
                          <div className="price">
                            <AiOutlineDollar /> $950 - $1100/mo.
                          </div>
                        </div>
                      </div>
                      <div className="jobboxholderbtm">
                        <div className="companyname">
                          <img src={Companylogojob1} alt="companylogo" />
                        </div>
                        <h6>
                          TechWave Solutions <span>San Francisco, CA</span>
                        </h6>
                      </div>
                    </div>
                  </div>
                  <div className="col-lg-3">
                    <div className="jobboxholder">
                      <div className="jobboxholdertop">
                        <h4>Registered Nurse</h4>
                        <p>
                          <MdOutlineWatchLater /> posted 3days ago
                        </p>
                        <div className="timeprice">
                          <div className="timezone">Part-Time</div>
                          <div className="price">
                            <AiOutlineDollar /> $600 - $750/mo.
                          </div>
                        </div>
                      </div>
                      <div className="jobboxholderbtm">
                        <div className="companyname">
                          <img src={Companylogojob2} alt="companylogo" />
                        </div>
                        <h6>
                          Riverside Hospital <span>Houston, TX</span>
                        </h6>
                      </div>
                    </div>
                  </div>
                  <div className="col-lg-3">
                    <div className="jobboxholder">
                      <div className="jobboxholdertop">
                        <h4>Marketing Manager</h4>
                        <p>
                          <MdOutlineWatchLater /> posted 3days ago
                        </p>
                        <div className="timeprice">
                          <div className="timezone">Full Time</div>
                          <div className="price">
                            <AiOutlineDollar /> $850 - $1000/mo.
                          </div>
                        </div>
                      </div>
                      <div className="jobboxholderbtm">
                        <div className="companyname">
                          <img src={Companylogojob3} alt="companylogo" />
                        </div>
                        <h6>
                          BrightMedia Agency <span>New York, NY</span>
                        </h6>
                      </div>
                    </div>
                  </div>
                  <div className="col-lg-3">
                    <div className="jobboxholder">
                      <div className="jobboxholdertop">
                        <h4>Warehouse Supervisor</h4>
                        <p>
                          <MdOutlineWatchLater /> posted 3days ago
                        </p>
                        <div className="timeprice">
                          <div className="timezone">Freelance</div>
                          <div className="price">
                            <AiOutlineDollar /> $25 - $40/hr.
                          </div>
                        </div>
                      </div>
                      <div className="jobboxholderbtm">
                        <div className="companyname">
                          <img src={Companylogojob4} alt="companylogo" />
                        </div>
                        <h6>
                          Global Logistics Inc. <span>Chicago, IL</span>
                        </h6>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section> */}
      </div>
      {/* <FooterScreen /> */}
    </>
  );
};
export default JobDetailsScreen;
